<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <main class="register">
    <form>
      <img class="img_glow_left" src="/static/images/home/glow.png">
      <section class="reg_1">

        <h1 v-if="!hasHE && !hasStepsToDisplay">{{ $_getTranslations.visitor_sign_up_register_three_steps }}</h1>
        <h1 v-else>{{ $_getTranslations.visitor_sign_up_register_two_steps }}</h1>

        <read-only-stepper-header
          v-if="!hasHE && !hasStepsToDisplay"
          :total-steps="3"
          :active-step="1"
        ></read-only-stepper-header>

        <read-only-stepper-header
          v-else
          :total-steps="2"
          :active-step="1"
        ></read-only-stepper-header>

        <img src="/static/images/register/mobile_img.svg" class="register_mobile" alt="mobile image">

        <p>{{ $_getTranslations.visitor_sign_up_1_single_country_info_msg_enter_msisdn }}</p>

        <base-phone-number-form-input
          v-model="user.msisdn"
          :label="$_getTranslations.visitor_sign_up_1_label_msisdn"
          :invalid="hasErrors"
          @keyup="check"
        ></base-phone-number-form-input>
        <div v-show="getMessage(message) && user.msisdn" class="error_text">{{ getMessage(message) }}</div>

        <p>{{ $_getTranslations.visitor_sign_up_free_for}}</p>

        <base-button
          :disabled="(hasErrors  || waitForResponse)"
          container-class="continue"
          @button:click.prevent="onSubmitAction"
        >{{ $_getTranslations.visitor_sign_up_1_single_country_continue }}</base-button>

        <p>
          {{ $_getTranslations.visitor_sign_up_already_have_account }}
          <router-link
            :to="'login'"
            class="text_links login"
          >{{ $_getTranslations.visitor_sign_up_login }}
          </router-link>
        </p>

        <div class="disclaimer">
          {{ $_getTranslations.visitor_sign_up_1_single_country_disclaimer_text }}
        </div>

      </section>
    </form>
    <simplify-registration v-if="showSimpleRegistrationModal"
                           @close="showSimpleRegistrationModal = false;">
    </simplify-registration>
    <confirm v-if="showConfirmationModal"
                  @confirm="showConfirmationModal = false;getNextVerificationStep()();"
                  @close="showConfirmationModal = false;">
    </confirm>
  </main>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import FlowMixin from '../../../common/mixins/flow';
import BaseButton from "../../common/button/BaseButton";
import IntegrationMixin from "../../../common/mixins/integration";
import translationMixin from "../../../common/mixins/translation";
import Confirm from "../../home/modals/Confirm";
import simplifyRegistration from "../../home/modals/SimplifyRegistration";
import BasePhoneNumberFormInput from "../../common/formInput/BasePhoneNumberFormInput";
import ReadOnlyStepperHeader from "../../common/header/ReadOnlyStepperHeader";

export default {
  name: 'sign-up-1-single-country',
  components: {ReadOnlyStepperHeader, BaseButton, Confirm, simplifyRegistration, BasePhoneNumberFormInput },
  mixins: [IntegrationMixin, FlowMixin, translationMixin],
  data() {
    return {
      operatorLogoForBrandedProject: '',
      btnSubmitted: false,
      operatorPicked: '',
      showSimpleRegistrationModal: false,
      user: {
        msisdn: '',
        hash: '',
      },
      message: '',
      hasErrors: false,
      hasHE: false,
      defaultImagePath: '/ext/banners/RegistrationDefault.png',
      imageUsed: '',
      waitForResponse: false,
      showConfirmationModal: false,
      hasStepsToDisplay: false,
      validationForOneTimeSubscription: null,
      disclaimers: ['visitor_sign_up_disclaimer_text1', 'visitor_sign_up_disclaimer_text2', 'visitor_sign_up_disclaimer_text3'],
    };
  },
  created() {
    this.hasStepsToDisplay = this.hasSteps();
    const numOfVisibleOperators = (this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.filter(item => item)).length;
    if (numOfVisibleOperators === 1) {
      const position = this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.indexOf(true);
      const operator = this.multiOperatorInfo.multiOperatorKeys[position];
      this.storeOperator(operator);
      this.operatorPicked = operator;
    }
    if (this.$route.query.errorMessage) this.message = this.getTranslatedErrorMessage(this.$route.query.errorMessage);
    if (this.message) {
      this.user.msisdn = this.$route.query.errorMsisdn || '';
      this.hasErrors = true;
    } else if (this.getIntegrationByName()) {
      this.user.msisdn = this.$route.query.heMsisdn || '';
      this.user.hash = this.$route.query.heHash || '';
      this.setCorrelationId({ value: this.$route.query.cid || '' });
      this.$nextTick(() => {
        this.hasHE = this.user.msisdn && this.user.hash && this.isSingleOptIn();
      });
    }
    this.imageUsed = this.banner ? `/ext/banners/${this.banner}.jpg` : this.defaultImagePath;
    this.validationForOneTimeSubscription = (!this.getIntegrationByName()) ? false : this.getIntegrationByName().value.oneTimeSubscription;
    this.operatorLogoForBrandedProject = this.isBrandedProject ? `static/skins/skin_${this.duelSkin.toString()}/images/logo-operator.svg` || 'static/images/logo-operator.svg' : '';
  },
  methods: {
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapMutations('common', [
      'updateMultiOperatorOrdinal',
      'setDefaultDailySubButtonEnabled',
      'setCorrelationId',
    ]),
    ...mapActions('common', [
      'storeOperator',
    ]),
    onSubmitActionForSubscriptionButtons(isDailySubscription) {
      this.setDefaultDailySubButtonEnabled(isDailySubscription);
      this.btnSubmitted = true;
      if (isDailySubscription) {
        this.checkButton(isDailySubscription);
      } else {
        const showModal = (!this.getIntegrationByName()) ? false : this.getIntegrationByName().value.showRegistrationModal;
        if (showModal) {
          this.showSimpleRegistrationModal = true;
        } else {
          this.checkButton(isDailySubscription);
        }
      }
    },
    showOperators() {
      const activeIntegration = this.getIntegrationByName();
      return !activeIntegration || !activeIntegration.value.affectsMultiOperator;
    },
    showDisclaimerNotice() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.operatorPicked;
      }
      return this.$_getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_free_for');
    },
    showDisclaimer() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.operatorPicked;
      }
      return this.$_getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer');
    },
    getOrdinalByOperator(operator) {
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((res) => {
        this.updateMultiOperatorOrdinal({ value: res.data.data.multiOperatorOrdinal });
      });
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.$_translateTextByOperator({key}) || '';
    },
    getTranslatedErrorMessage(errorMessage) {
      switch (errorMessage) {
      case 'MSISDN_INVALID': return 'visitor_sign_up_invalid_msisdn_msg';
      case 'ALREADY_REGISTERED': return 'visitor_sign_up_msisdn_already_registered';
      case 'MSISDN_NOT_EXIST': return 'visitor_sign_up_msisdn_not_exists';
      case 'MSISDN_BLACKLISTED': return 'visitor_sign_up_msisdn_blacklisted';
      case 'BLOCKED_USER': return 'visitor_forgot_password_warning_msd_max_attempts';
      case 'CAMPAIGN_CLOSED': return 'visitor_sign_up_campaign_closed';
      case 'SERVER_ERROR': return 'home_profile_profile_edit_server_unvailable';
      default: return 'visitor_sign_up_warning_third_party_error';
      }
    },
    getOperatorImage(operatorIndex) {
      return this.$_getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    imageErrorHandler() {
      this.imageUsed = this.defaultImagePath;
    },
    check() {
      const validMsisdnRegex = /^[0-9]{0,20}$/ // /^([0-9]|[()+-]){0,20}$/;
      const validMsisdn = this.user.msisdn.match(validMsisdnRegex);
      if (!validMsisdn) {
        this.message = 'visitor_sign_up_invalid_msisdn_msg';
        this.hasErrors = true;
      } else {
        sessionStorage.setItem('msisdn', this.user.msisdn);
        this.hasErrors = false;
        this.message = '';
      }
    },
    mapErrorMessages(resMessage) {
      this.hasErrors = true;
      if (resMessage === 'OPERATION_SUCCESS') {
        this.hasErrors = false;
      }
      if (resMessage === 'MSISDN_INVALID') {
        this.message = 'visitor_sign_up_invalid_msisdn_msg';
      } else if (resMessage === 'ALREADY_REGISTERED') {
        this.message = 'visitor_sign_up_msisdn_already_registered';
      } else if (resMessage === 'MSISDN_NOT_EXIST') {
        this.message = 'visitor_sign_up_msisdn_not_exists';
      } else if (resMessage === 'MSISDN_BLACKLISTED') {
        this.message = 'visitor_sign_up_msisdn_blacklisted';
      } else if (resMessage === 'BLOCKED_USER') {
        this.message = 'visitor_forgot_password_warning_msd_max_attempts';
      } else if (resMessage === 'CAMPAIGN_CLOSED') {
        this.message = 'visitor_sign_up_campaign_closed';
      } else if (resMessage === 'SERVER_ERROR') {
        this.message = 'home_profile_profile_edit_server_unvailable';
      } else if ((resMessage === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resMessage === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resMessage === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
        this.message = 'visitor_sign_up_warning_third_party_error';
      }
    },
    onSubmitAction() {
      this.btnSubmitted = true;
      if (!this.multiOperatorInfo.multiOperatorEnabled || (this.multiOperatorInfo.multiOperatorEnabled && this.operatorPicked)) {
        this.checkButton();
      } else {
        this.hasErrors = true;
      }
    },
    checkButton() {
      const activeIntegration = this.getIntegrationByName();
      if (activeIntegration && activeIntegration.value.hasConfirmation && this.isSingleOptIn()) {
        this.showConfirmationModal = true;
      } else {
        const appropriateRequestPinStep = this.getAlternateRequestPinAction()(this.user.msisdn, this.operatorPicked);
        if (appropriateRequestPinStep) {
          appropriateRequestPinStep.call(this);
        } else this.getNextVerificationStep()();
      }
    },
  },
  computed: {
    ...mapState('common', [
      'duelSkin',
      'banner',
      'isBrandedProject',
      'multiOperatorInfo',
    ])
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/SignUp1SingleCountry.vue